import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=2427751f&scoped=true&"
import script from "./admins.vue?vue&type=script&lang=js&"
export * from "./admins.vue?vue&type=script&lang=js&"
import style0 from "./admins.vue?vue&type=style&index=0&id=2427751f&prod&lang=scss&scoped=true&"
import style1 from "./admins.vue?vue&type=style&index=1&id=2427751f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427751f",
  null
  
)

export default component.exports